import { dynamicLoader } from '~/utils';

export const HomePage = dynamicLoader({
  name: 'HomePage',
  importFunc: () => import('./home'),
});